import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { PershingTranslationService } from '@pershing/pershing-core';

@Component({
    selector: 'download-excel',
    templateUrl: './download-excel.component.html',
    styleUrls: ['./download-excel.component.css']
})
export class DownloadExcelComponent implements OnInit {
    @Input() asofTime: any;
    @Output() downloadOption = new EventEmitter();
    constructor( private translationService: PershingTranslationService) {
        this.translationService.addTranslationFolder('@pershing/nxi-common', 'node_modules/@pershing/nxi-common/lib');
    }
    ngOnInit() {
    }
    download(dwval: any) {
        this.downloadOption.emit(dwval);
    }
}
